import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import React__default, { useRef, useState, useEffect, useCallback } from 'react';
import { Popper as Popper$1 } from 'react-popper';
import './Popper.scss.js';
import useClickOutside from '../../../hooks/useClickOutside.js';
import { createPortal } from 'react-dom';

var Popper = function Popper(_ref) {
  var children = _ref.children,
      show = _ref.show,
      toggleRef = _ref.toggleRef,
      position = _ref.position,
      style = _ref.style,
      offset = _ref.offset,
      popperRef = _ref.popperRef,
      containerRef = _ref.containerRef,
      onClose = _ref.onClose,
      strategy = _ref.strategy;
  var contentRef = useRef(null);

  var _useState = useState((containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) || document.body),
      _useState2 = _slicedToArray(_useState, 2),
      container = _useState2[0],
      setContainer = _useState2[1];

  useEffect(function () {
    if (containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) {
      setContainer(containerRef.current);
    }
  }, [containerRef === null || containerRef === void 0 ? void 0 : containerRef.current]);
  /** Функция для отслеживания клика вне элемента */

  var handleClickOutside = useCallback(function (event) {
    if (event.target && toggleRef.current && toggleRef.current.contains(event.target)) {
      return;
    } // Отлавливаем клик по вложенному попперу.
    // Полагаемся на то, что вложенный открылся позже родительского и его контейнер в DOM будет идти после родительского.


    var container = (popperRef || contentRef).current;
    var clickContainer = event.target.closest('.rf-popper__content');

    if (container && clickContainer && container.compareDocumentPosition(clickContainer) === Node.DOCUMENT_POSITION_FOLLOWING) {
      return;
    }

    onClose();
  }, [onClose, toggleRef]);
  useClickOutside(popperRef || contentRef, handleClickOutside);

  if (!show) {
    return null;
  }

  var content = /*#__PURE__*/React__default.createElement(Popper$1, {
    placement: position,
    strategy: strategy,
    modifiers: [{
      name: 'offset',
      options: {
        offset: offset || [0, 8]
      }
    }, {
      name: 'recalculateSize',
      enabled: true,
      phase: 'afterMain',
      fn: function fn() {}
    }, {
      name: 'flip',
      options: {
        allowedAutoPlacements: ['right', 'left', 'top', 'bottom'],
        rootBoundary: 'viewport'
      }
    }],
    innerRef: popperRef || contentRef,
    "data-v-6e52f9c7": ""
  }, function (_ref2) {
    var ref = _ref2.ref,
        dropdownStyle = _ref2.style;
    return /*#__PURE__*/React__default.createElement("div", {
      ref: ref,
      style: Object.assign(Object.assign({}, dropdownStyle), style),
      className: "rf-popper__content",
      "data-testid": "rf-popper",
      "data-v-6e52f9c7": ""
    }, children);
  });
  return /*#__PURE__*/createPortal(content, container);
};

export { Popper as default };
